import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "../api/axios";
import { useAuth } from "../context/AuthProvider";
import { Helmet } from "react-helmet-async";
import './styles/LoginSignup.css';

const ForgotPassword = () => {
  const { auth } = useAuth();
  const [identifier, setIdentifier] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [sending, setSending] = useState(false);
  const [cooldown, setCooldown] = useState(0);

  // Cooldown timer effect
  useEffect(() => {
    if (cooldown > 0) {
      const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [cooldown]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (sending || cooldown > 0) return;
    setMessage("");
    setError("");
    setSending(true);

    try {
      const res = await axios.post("/api/auth/forgot-password", { identifier });
      // Use backend-provided message here!
      setMessage(res.data.message);
    } catch (err) {
      // Ignore backend errors for security
        setMessage(
        err.response?.data?.message ||
          "If there is an account associated with this email or username, and an email is set for that account, you will receive a password reset link. If you do not receive an email after a few minutes, please check your spam or junk folder. If you still do not receive anything, please contact your website administrator for further assistance."
      );
    } finally {
      // Show spinner for 1s, THEN show message and start cooldown
      setTimeout(() => {
        setSending(false);
        setCooldown(30); // 30s cooldown
      }, 500);
    }
  };

  return (
    <>
      <Helmet>
      <title>Admin - Website Name</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
    <div className="auth-page-wrapper">
      <div className="auth-container">
        <h2>Forgot Password</h2>
        <p>Remembered your password? <Link to="/login">Login</Link></p>

        {/* Show message only when not sending */}
        {message && !sending && (
          <p className="success" aria-live="polite" style={{marginTop: 12}}>{message}</p>
        )}
        {error && <p className="error" aria-live="polite">{error}</p>}

        <form onSubmit={handleSubmit} autoComplete="off">
          <label htmlFor="forgot-password-identifier" className="sr-only">Enter your email address</label>
          <input
            id="forgot-password-identifier"
            type="text"
            placeholder="Enter your email or username"
            autoComplete="username"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            disabled={sending || cooldown > 0}
            required
          />
          <button
            type="submit"
            disabled={sending || !identifier || cooldown > 0}
            aria-label="Send password reset link"
            className={sending || cooldown > 0 ? "btn-disabled" : ""}
          >
            {sending
              ? <div className="spinner"></div>
              : cooldown > 0
                ? `Try again in ${cooldown}s`
                : "Send Reset Link"}
          </button>
        </form>
      </div>
    </div>
    </>
  );
};

export default ForgotPassword;